import React, { Component } from "react";
import Static from "../../../components/Static/Static";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : StaticForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina – Se llama al componente de Static con sus respectivos parámetros.
================================================================================ */

class StaticForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <Static/>
        )
    }
}

export default StaticForm;